module.exports = "/_next/static/images/d3cefa4a84c61095c717d7accefda653-purple-phone-icon.svg";